import React, { Component } from "react";

import {Context, ContextUtil} from "../tools/context";
import {authCall} from "../tools/apitools";
import '../style/home.scss'


class Home extends Component {
  constructor() {
    super();

    this.state={
      shortCode: Context.seller.shortcode || null,
    }
  }

  componentDidMount() {
    console.log(Context)
    if (!Context.seller.shortcode) {
      authCall(
        '/api/bienvenus/seller/',
        {},
        r => {
          this.setState({shortCode: r.shortcode});
          ContextUtil.update('seller', r);
        },
        () => console.log('perdu'),
      )
    }
  }


  render() {
    return (
      <div>
        <div className="homePage_backGroundImage1">
          {/* centre le tout */}
          <div className="homePageBody border">
            <h1 className="homePage_MainTitle">
              BIENVENUE DANS VOTRE ESPACE COMMERÇANT
            </h1>
            <p className="homePage_Titles">
              RAPPROCHEZ-VOUS DE VOTRE COMMUNE POUR RÉCUPÉRER VOTRE AFFICHETTE
              ET VITROPHANIE AFIN DE COMMUNIQUER EN MAGASIN
            </p>
            <p className="startDate">
              L'OPÉRATION TICKET COMMERÇANT® DÉBUTE À PARTIR DU 1 FÉVRIER 2021
            </p>
            <p className="homePage_whiteButton">
              JE DECOUVRE MON TABLEAU DE BORD
            </p>
            <p className="homePage_Titles">
              VOICI VOTRE CODE COMMERÇANT QUI SERA UTILISÉ EN TANT
              QU'IDENTIFIANT PAR VOS CLIENTS POUR VOUS ATTRIBUER UN TICKET
              COMMERÇANT.
            </p>
            <p className="homePage_whiteButton sellerCode">{this.state.shortCode}</p>
            <p className="homePage_Titles">
              COMPLÉTEZ VOS INFORMATIONS PERSONNELLES
            </p>
            <p className="homePage_whiteButton">
              JE RENSEIGNE MES INFORMATIONS PERSONNELLES
            </p>
            <p className="homePage_Titles">
              VOUS POUVEZ TÉLÉCHARGER CI-DESSOUS VOTRE KIT DE COMMUNICATION
              EXPLIQUANT LES DÉTAILS DE L'OPÉRATION À VOS CLIENTS.
            </p>
            <p className="homePage_whiteButton">
              <a href="https://s3-eu-west-3.amazonaws.com/tourismebyca/wp-content/uploads/2020/08/30133644/KitCommer%C3%A7ants.zip">
                JE TÉLÉCHARGE MON KIT DE COMMUNICATION
              </a>
            </p>
            <p className="homePage_LogOut">JE ME DÉCONNECTE</p>
          </div>
        </div>
        <div>
          <h1 className="process_title">Comment ça marche?</h1>
        </div>

        <div className="process_Wrapper">
          <div>
            <picture className="backGroundImage2">
              <source
                media="(max-width: 992px)"
                srcset="https://s3-eu-west-3.amazonaws.com/tourismebyca/wp-content/uploads/2020/08/26170155/750x118.png"
              />
              <img
                src="https://s3-eu-west-3.amazonaws.com/tourismebyca/wp-content/uploads/2020/08/08173558/commentcamarche-1.png"
                alt="some picture"
              />
            </picture>
          </div>

          <div className="helpDesk">
            <p>CE N'EST PAS CLAIR ?</p>
            <p>UN NUMERO VERT VOUS ACCOMPAGNE</p>
            <p> 09 80 80 37 49</p>
          </div>
        </div>

        <div className="homePage_footer">
          <div>
            <img
              src="https://s3-eu-west-3.amazonaws.com/tourismebyca/wp-content/uploads/2020/08/27111840/logo_bdt_vertical.png"
              alt="banque des territoires"
            />
          </div>
          <div>
            <img
              src="https://s3-eu-west-3.amazonaws.com/tourismebyca/wp-content/uploads/2020/08/25231114/LogoLavalAgglo.png"
              alt="laval agglo"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Home;
